var App = App || {};

App.MemberProfile = (function ($) {
    "use strict";

	function init() {
        const $profileTabs = $(".block.block-member-profile-tabs");

        if ($profileTabs) {
            $profileTabs.each(function () {
                var $tabSet = $(this),
                    tabSetId = $tabSet.attr("id"),
                    activeTab = new URLSearchParams(window.location.search).get('activeTab') || sessionStorage.getItem("activeTab-" + tabSetId);

                $tabSet.find("button[data-bs-toggle='tab']").on("show.bs.tab", function (e) {
                    sessionStorage.setItem("activeTab-" + tabSetId, $(e.target).attr("id"));
                });

                if (activeTab) {
                    var $activeButton = $("button#" + activeTab);
                    $activeButton.tab("show");

                    const urlQueries = new URLSearchParams(window.location.search)
                    if (urlQueries.has($activeButton.attr("data-pagination-key"))) {
                        $('html, body').animate({
                            scrollTop: $tabSet.offset().top
                        }, 100);
                    }
                }

                $tabSet.find("button[data-pagination-key='Notifications']").on("hide.bs.tab", function (e) {
                    $($(this).attr("data-bs-target"))
                        .find(".notification-box-wrapper")
                        .removeClass("animate__animated animate__fadeInUp");
                });

                $tabSet.find("button[data-pagination-key='Notifications']").on("show.bs.tab", function (e) {
                    $tabSet.ZagScrollAnimate({
                        offset: 75,
                        targets: [
                            { selector: ".notification-box-wrapper", type: "animate__fadeInUp", stagger: 150 }
                        ]
                    });
                });

                ///
                /// Contact Form
                ///

                var $contactForm = $tabSet.find("form#contact-update-form"),
                    $contactEditButton = $tabSet.find("button#contact-edit-button"),
                    $contactSaveButton = $tabSet.find("button#contact-save-button");

                $contactForm.on("submit", function (e) {
                    e.preventDefault();

                    var $summary = $contactForm.find(".form-validation-message");
                    $summary.empty();

                    if ($contactForm[0].checkValidity()) {
                        App.Spinner.startSpinner($contactSaveButton, "Saving");

                        var payload = {
                            firstName: $contactForm.find("#contact_firstName").val(),
                            lastName: $contactForm.find("#contact_lastName").val(),
                            email: $contactForm.find("#contact_email").val()
                        };

                        $.ajax({
                            url: '/api/contact/update',
                            contentType: 'application/json; charset=utf-8',
                            method: 'POST',
                            data: JSON.stringify(payload),
                            dataType: 'json'
                        }).done(function (data, textStatus, jqXHR) {
                            $tabSet.find("input")
                                .prop("disabled", true)
                                .addClass("default-disabled");
                            App.Base.ShowInformation(data.message);
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            App.Base.ShowError("Unable to complete request. Please try again.");
                        }).always(function () {
                            $contactEditButton.show();
                            $contactSaveButton.hide();
                            App.Spinner.stopSpinner($contactSaveButton);
                        });
                    }

                    $contactForm.addClass('was-validated');
                });

                $contactEditButton.on("click", function (e) {
                    e.preventDefault();

                    $contactForm.find("input")
                        .prop("disabled", false)
                        .removeClass("default-disabled");
                    $contactEditButton.hide();
                    $contactSaveButton.show();
                });

                ///
                /// Account Form
                ///

                var $accountForm = $tabSet.find("form#account-update-form"),
                    $accountEditButton = $tabSet.find("button#account-edit-button"),
                    $accountSaveButton = $tabSet.find("button#account-save-button");

                $accountForm.on("submit", function (e) {
                    e.preventDefault();

                    var $summary = $accountForm.find(".form-validation-message");

                    $summary.empty();

                    if ($accountForm[0].checkValidity()) {
                        App.Spinner.startSpinner($accountSaveButton, "Saving");

                        var payload = {
                            firmName: $accountForm.find("#account_firmName").val(),
                            address1: $accountForm.find("#account_address1").val(),
                            address2: $accountForm.find("#account_address2").val(),
                            city: $accountForm.find("#account_city").val(),
                            state: $accountForm.find("#account_state").val(),
                            postalCode: $accountForm.find("#account_postalCode").val(),
                            phone: $accountForm.find("#account_phone").val(),
                        };

                        $.ajax({
                            url: '/api/account/update',
                            contentType: 'application/json; charset=utf-8',
                            method: 'POST',
                            data: JSON.stringify(payload),
                            dataType: 'json'
                        }).done(function (data, textStatus, jqXHR) {
                            $accountForm.find("input")
                                .prop("disabled", true)
                                .addClass("default-disabled");

                            App.Base.ShowInformation(data.message);
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            App.Base.ShowError("Unable to complete request. Please try again.");
                        }).always(function () {
                            $accountEditButton.show();
                            $accountSaveButton.hide();
                            App.Spinner.stopSpinner($accountSaveButton);
                        });
                    }

                    $accountForm.addClass('was-validated');
                });

                $accountEditButton.on("click", function (e) {
                    e.preventDefault();

                    $accountForm.find("input")
                        .prop("disabled", false)
                        .removeClass("default-disabled");

                    $accountEditButton.hide();
                    $accountSaveButton.show();
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.MemberProfile.init();
});